import type { ExperimentKey, CalculusExperimentDef } from '../types';
import { experiment as limitLab } from './limit-lab';
import { experiment as tangentLab } from './tangent-lab';
import { experiment as derivativePlotter } from './derivative-plotter';
import { experiment as applications } from './applications';
import { experiment as riemannLab } from './riemann-lab';
import { experiment as ftcLab } from './ftc-lab';
import { experiment as taylorLab } from './taylor-lab';
import { experiment as slopeFieldLab } from './slope-field-lab';

// ============================================================================
// Experiment Registry
// ============================================================================
// All 8 experiments registered. Record<> is fully satisfied (no Partial).

export const EXPERIMENTS: Record<ExperimentKey, CalculusExperimentDef> = {
  'limit-lab': limitLab,
  'tangent-lab': tangentLab,
  'derivative-plotter': derivativePlotter,
  applications: applications,
  'riemann-lab': riemannLab,
  'ftc-lab': ftcLab,
  'taylor-lab': taylorLab,
  'slope-field-lab': slopeFieldLab,
};

/**
 * Curriculum order: limits → derivatives → integrals → series → fields.
 * Populated incrementally as experiments are added.
 */
export const EXPERIMENT_ORDER: ExperimentKey[] = [
  'limit-lab',
  'tangent-lab',
  'derivative-plotter',
  'applications',
  'riemann-lab',
  'ftc-lab',
  'taylor-lab',
  'slope-field-lab',
];
